import { SOLAR_MODULE_COLOR, SOLAR_MODULE_STROKE_COLOR } from '../constants';

const STROKE_WEIGHT = 0.5;

export default (google) => {
    class SolarModulePolygon extends google.maps.Polygon {
        id = null;
        moduleEnable = true;
        onClick = null;
        parentId = null;

        constructor({
            cell = null,
            col = null,
            group = null,
            id,
            isHidden = false,
            map,
            moduleEnable = true,
            onClick,
            onClickHide,
            parentId = null,
            paths,
            row = null,
            zIndex = 2,
        } = {}) {
            super({
                clickable: false,
                fillColor: SOLAR_MODULE_COLOR,
                fillOpacity: 1,
                map,
                paths,
                strokeColor: SOLAR_MODULE_STROKE_COLOR,
                strokePosition: google.maps.StrokePosition.OUTSIDE,
                strokeWeight: STROKE_WEIGHT,
                zIndex,
                visible: moduleEnable,
            });
            this.cell = cell;
            this.col = col;
            this.group = group;
            this.id = id;
            this.parentId = parentId;
            this.row = row;
            this.google = google;
            this.isHidden = isHidden;
            this.moduleEnable = moduleEnable;

            this.handleModuleEnableStatus(moduleEnable);

            if (this.isHidden) this.setOptions({ fillOpacity: 0.5 });
            if (onClick) this.onClick = onClick;
            if (onClickHide) this.onClickHide = onClickHide;
        }

        setDisabled(isDisabled = true) {
            if (isDisabled) {
                this.setOptions({
                    fillOpacity: 0,
                    strokeWeight: 0,
                });
            } else {
                this.setOptions({
                    fillOpacity: 1,
                    strokeWeight: STROKE_WEIGHT,
                });
            }
        }

        handleModuleEnableStatus(isEnable) {
            this.moduleEnable = isEnable;
            this.setOptions({
                fillOpacity: Number(isEnable),
                strokeWeight: isEnable ? 1 : 0.5,
            });
        }

        setEnableModulesToEdit(isEnabled = false, onlyHide = false) {
            const fillOpacity = this.isHidden ? 0.5 : Number(this.moduleEnable);

            this.setOptions({
                clickable: isEnabled,
                fillOpacity,
                strokeWeight: STROKE_WEIGHT,
                visible: isEnabled || this.isHidden,
            });

            google.maps.event.clearListeners(this, 'click');

            if (isEnabled)
                google.maps.event.addListener(
                    this,
                    'click',
                    ({ domEvent: { shiftKey } }) => {
                        if (shiftKey && this.onClickHide) {
                            this.onClickHide(this);
                            this.isHidden = !this.isHidden;
                            this.setOptions({
                                fillOpacity: this.isHidden ? 0.5 : 1,
                            });

                            return;
                        }
                        if (this.onClick && !onlyHide) this.onClick(this);
                    },
                );
            else if (this.moduleEnable) this.setOptions({ visible: true });
        }

        setNewZIndex(zIndex) {
            this.setOptions({ zIndex });
        }
    }

    return SolarModulePolygon;
};
